import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/system";
import { isValidElement } from "react";
import BryxColors from "../../types/theme";
const ITEM_HEIGHT = 24;
const BryxActionMenuItem = styled(({ onClick, content, ...props }) => {
    const { isOpen, ...rest } = props;
    // Why do we need Typography here? -- https://mui.com/material-ui/react-menu/#limitations
    let renderedContent = _jsx(Typography, { noWrap: true, children: content });
    if (isValidElement(content)) {
        renderedContent = content;
    }
    return (_jsx(MenuItem, { onClick: onClick, ...rest, tabIndex: 0, children: renderedContent }));
})(({ theme, isOpen }) => {
    const styles = isOpen
        ? {
            backgroundColor: BryxColors.brand3(theme.palette.mode),
            color: BryxColors.brandPrimary(theme.palette.mode),
            "& > .MuiTypography-root": {
                color: BryxColors.brandPrimary(theme.palette.mode),
                fontSize: "13px",
                width: "100%",
            },
        }
        : {};
    return {
        height: `${ITEM_HEIGHT}px`,
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingRight: "0px",
        "&&:hover": {
            backgroundColor: BryxColors.brand3(theme.palette.mode),
            color: BryxColors.brandPrimary(theme.palette.mode),
            "& > .MuiTypography-root": {
                color: BryxColors.brandPrimary(theme.palette.mode),
            },
        },
        "& > .MuiTypography-root": {
            color: BryxColors.notify(theme.palette.mode, "inactive"),
            fontSize: "13px",
            width: "100%",
        },
        "& > .MuiMenuItem-root:focus:not(:hover, .Mui-selected)": {
            color: BryxColors.notify(theme.palette.mode, "inactive"),
        },
        ...styles,
    };
});
export default BryxActionMenuItem;
